module.exports = __webpack_public_path__ + "img/arsenal.2dfa9cec.png";